import {
  Box,
  Fade,
  Modal,
  Grid,
  Button,
  useMediaQuery,
  Divider,
  IconButton,
  styled,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Close } from "@mui/icons-material";
import CInput from "../CInput";
import theme from "../../config/theme";
import moment from "moment";
import _, { isEmpty } from "lodash";
import { getApiData, getNewApiData, postFormData } from "../../utils/APIHelper";
import { Setting } from "../../utils/Setting";
import { toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

const MAX_SPECIFICATION_LENGTH = 1000;

const errorObj = {
  bNameErr: false,
  bNameMsg: "",
  materialTypeErr: false,
  materialTypeMsg: "",
  materialUnitErr: false,
  materialUnitMsg: "",
  specificationsErr: false,
  specificationsMsg: "",
  descriptionErr: false,
  descriptionMsg: "",
  costErr: false,
  costMsg: "",
};

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

function InclusionModal({
  isCreationOpen,
  visible,
  handleCloseCreation,
  selectedBudget,
  isEdit,
  packageId,
  getProjectDetails,
  isGroup,
}) {
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const md = useMediaQuery(theme.breakpoints.down("md"));

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: sm ? 300 : 600,
    bgcolor: "background.paper",
    borderRadius: 1,
    boxShadow: 24,
    padding: "2vh 2vw",
    fontFamily: "Inter Tight",
    maxHeight: "77vh",
    overflowY: "scroll",
    scrollbarWidth: "none", // For Firefox
    "&::-webkit-scrollbar": {
      display: "none", // For Chrome, Safari, and Edge
    },
  };

  const [errObj, setErrObj] = useState(errorObj);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [budgetDetails, setBudgetDetails] = useState({
    name: "",
    materialType: "",
    materialUnit: "",
    specifications: "",
    updatedAt: moment().format("MMM DD, YYYY"),
    id: "",
    description: "",
    imageMetadata: "",
    varaints: [],
  });

  const submitMilestone = async (data, isEditFlag) => {
    console.log("Data", data);
    setButtonLoader(true);
    try {
      const method = isEditFlag ? "PUT" : "POST";
      const url = isEditFlag
        ? `/api/v2/package/${packageId}/boq/${budgetDetails?.id}`
        : `/api/v2/package/${packageId}/boq`;

      const response = await getNewApiData(
        url,
        method,
        data,
        { "Content-Type": "application/json" },
        true
      );

      if (response) {
        toast.success(
          isEditFlag
            ? "Budget Updated Successfully"
            : "Budget Added Successfully"
        );
        getProjectDetails(packageId);
        handleCloseCreation();
      }
    } catch (error) {
      toast.error(error.toString());
    } finally {
      setButtonLoader(false);
    }
  };

  const validate = () => {
    const error = { ...errObj };
    let valid = true;

    if (isEmpty(budgetDetails?.name?.trim())) {
      valid = false;
      error.bNameErr = true;
      error.bNameMsg = "Please enter budget name";
    }

    if (isEmpty(budgetDetails?.description?.trim())) {
      valid = false;
      error.descriptionErr = true;
      error.descriptionMsg = "Please enter description";
    }

    if (isEmpty(budgetDetails?.materialType)) {
      valid = false;
      error.materialTypeErr = true;
      error.materialTypeMsg = "Please enter material type";
    }

    if (isGroup) {
      if (
        budgetDetails.cost === "" ||
        isNaN(budgetDetails.cost) ||
        parseFloat(budgetDetails.cost) < 0
      ) {
        valid = false;
        error.costErr = true;
        error.costMsg = "Please enter a valid cost";
      }
    }

    if (
      !budgetDetails?.materialUnit ||
      isNaN(parseFloat(budgetDetails?.materialUnit))
    ) {
      valid = false;
      error.materialUnitErr = true;
      error.materialUnitMsg = "Please enter a valid material unit";
    }

    if (isEmpty(budgetDetails?.specifications?.trim())) {
      valid = false;
      error.specificationsErr = true;
      error.specificationsMsg = "Please enter specification of the budget";
    }

    setErrObj(error);

    if (valid) {
      let body = {
        name: budgetDetails?.name,
        description: budgetDetails?.description,
        specifications: budgetDetails?.specifications,
        materialType: budgetDetails?.materialType,
        materialUnit: budgetDetails?.materialUnit,
      };

      // Only add cost if it's a group
      if (isGroup) {
        body.cost = parseFloat(budgetDetails?.cost);
      }

      // If in edit mode, add ids
      if (isEdit) {
        body = {
          ...body,
          id: parseInt(budgetDetails?.id),
          packageId: parseInt(packageId),
        };
      } else {
        body = {
          ...body,
          metadata: "",
          imageMetadata: budgetDetails?.imageMetadata
            ? JSON.stringify(budgetDetails?.imageMetadata)
            : "",
        };
      }

      console.log("body", body);
      submitMilestone(body, isEdit);
    }
  };

  useEffect(() => {
    if (selectedBudget && Object.keys(selectedBudget).length > 0) {
      console.log("selectedM", selectedBudget);
      setBudgetDetails(selectedBudget);
    }
  }, [selectedBudget]);

  if (typeof budgetDetails?.imageMetadata === "string") {
    try {
      setBudgetDetails({
        ...budgetDetails,
        imageMetadata: JSON.parse(budgetDetails?.imageMetadata),
      });
    } catch (e) {
      console.error("Error parsing image metadata:", e);
    }
  }

  const handleBoqImage = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file_1", file);
      formData.append("type", "package_boq");
      formData.append("tags", "");

      try {
        const response = await postFormData(
          Setting.endpoints.packageFiles,
          formData
        );
        if (response.success) {
          setBudgetDetails({
            ...budgetDetails,
            imageMetadata: response.images[0],
          });
          toast.success("BOQ Image uploaded successfully");
        } else {
          toast.error("File upload failed");
        }
      } catch (error) {
        toast.error("An error occurred during file upload");
      }
    }
  };

  const handleDeleteImage = async () => {
    setButtonLoader(true);
    try {
      const response = await getApiData(
        `api/project/delete-files/${budgetDetails?.imageMetadata?.id}`,
        "POST",
        {},
        { "Content-Type": "application/json" },
        false
      );
      if (response.success) {
        setBudgetDetails({ ...budgetDetails, imageMetadata: "" });
        toast.success(response?.message);
        setButtonLoader("");
      }
    } catch (error) {
      toast.error(error.toString());
      setButtonLoader("");
    }
  };

  return (
    <>
      <Modal open={isCreationOpen || visible} onClose={handleCloseCreation}>
        <Fade in={isCreationOpen || visible}>
          <Box sx={style}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="addMilestoneHeader">
                {isEdit ? "Update" : "Add"} Budget Item
              </div>
              <Close
                style={{ cursor: "pointer" }}
                onClick={() => handleCloseCreation()}
              />
            </div>
            <Grid container>
              <Grid item xs={12} id="name" mt={2}>
                <CInput
                  label={<span>Budget Item Name</span>}
                  placeholder="Enter Budget Name..."
                  value={budgetDetails?.name}
                  onChange={(e) => {
                    setBudgetDetails({
                      ...budgetDetails,
                      name: e.target.value,
                    });
                    setErrObj({
                      ...errObj,
                      bNameErr: false,
                      bNameMsg: "",
                    });
                  }}
                  inputProps={{ maxLength: 50 }}
                  error={errObj.bNameErr}
                  helpertext={errObj.bNameMsg}
                />
              </Grid>

              <Grid item xs={12} id="description" mt={2}>
                <CInput
                  multiline
                  rows={3}
                  label={<span>Budget Item Description:</span>}
                  placeholder="Enter Budget Description (Max upto 1000 characters)"
                  value={budgetDetails?.description}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= MAX_SPECIFICATION_LENGTH) {
                      setBudgetDetails({
                        ...budgetDetails,
                        description: e.target.value,
                      });
                      setErrObj({
                        ...errObj,
                        descriptionErr: false,
                        descriptionMsg: "",
                      });
                    }
                  }}
                  error={errObj.descriptionErr}
                  helpertext={
                    errObj.descriptionMsg
                      ? errObj.descriptionMsg
                      : `${
                          MAX_SPECIFICATION_LENGTH -
                          (budgetDetails?.description?.length || 0)
                        } characters left`
                  }
                />
              </Grid>

              <Grid item xs={12} id="materialType" mt={2}>
                <CInput
                  label={<span>Material Type</span>}
                  placeholder="marble, wood, etc..."
                  value={budgetDetails?.materialType}
                  onChange={(e) => {
                    setBudgetDetails({
                      ...budgetDetails,
                      materialType: e.target.value,
                    });
                    setErrObj({
                      ...errObj,
                      materialTypeErr: false,
                      materialTypeMsg: "",
                    });
                  }}
                  error={errObj.materialTypeErr}
                  helpertext={errObj.materialTypeMsg}
                />
              </Grid>

              <Grid item xs={12} id="materialUnit" mt={2}>
                <CInput
                  label={<span>Material Unit</span>}
                  placeholder="Enter material quantity"
                  value={budgetDetails?.materialUnit}
                  onChange={(e) => {
                    const value = e.target.value;
                    const regex = /^\d{0,10}(\.\d{0,2})?$/; // Max 10 digits before decimal, up to 2 decimal places

                    if (value === "" || regex.test(value)) {
                      setBudgetDetails({
                        ...budgetDetails,
                        materialUnit: value,
                      });
                      setErrObj({
                        ...errObj,
                        materialUnitErr: false,
                        materialUnitMsg: "",
                      });
                    }
                  }}
                  onBlur={() => {
                    if (budgetDetails?.materialUnit) {
                      const numValue = parseFloat(budgetDetails.materialUnit);
                      if (!isNaN(numValue)) {
                        setBudgetDetails({
                          ...budgetDetails,
                          materialUnit: numValue.toString(),
                        });
                      }
                    }
                  }}
                  error={errObj.materialUnitErr}
                  helpertext={errObj.materialUnitMsg}
                />
              </Grid>

              {isGroup && (
                <>
                  <Grid item xs={12} id="cost" mt={2}>
                    <CInput
                      label={<span>Cost</span>}
                      placeholder="Enter cost"
                      value={budgetDetails?.cost}
                      onChange={(e) => {
                        const value = e.target.value;
                        const regex = /^\d{0,10}(\.\d{0,2})?$/; // Max 10 digits before decimal, up to 2 decimal places

                        if (value === "" || regex.test(value)) {
                          setBudgetDetails({
                            ...budgetDetails,
                            cost: value,
                          });
                          setErrObj({
                            ...errObj,
                            costErr: false,
                            costMsg: "",
                          });
                        }
                      }}
                      onBlur={() => {
                        if (budgetDetails?.cost) {
                          const numValue = parseFloat(budgetDetails.cost);
                          if (!isNaN(numValue)) {
                            setBudgetDetails({
                              ...budgetDetails,
                              cost: numValue.toString(),
                            });
                          }
                        }
                      }}
                      error={errObj.costErr}
                      helpertext={errObj.costMsg}
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={12} id="name" mt={2}>
                <CInput
                  label={<span>Specification</span>}
                  placeholder="Write here (Max upto 1000 characters)"
                  value={budgetDetails?.specifications}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= MAX_SPECIFICATION_LENGTH) {
                      setBudgetDetails({
                        ...budgetDetails,
                        specifications: e.target.value,
                      });
                      setErrObj({
                        ...errObj,
                        specificationsErr: false,
                        specificationsMsg: "",
                      });
                    }
                  }}
                  error={errObj.specificationsErr}
                  helpertext={
                    errObj.specificationsMsg
                      ? errObj.specificationsMsg
                      : `${
                          MAX_SPECIFICATION_LENGTH -
                          (budgetDetails?.specifications?.length || 0)
                        } characters left`
                  }
                />
              </Grid>
              {!isEdit && (
                <>
                  <Grid
                    item
                    xs={12}
                    id="package_boq"
                    marginBottom={1}
                    marginTop={1}
                  >
                    <Button
                      variant="outlined"
                      startIcon={<AddIcon />}
                      component="label"
                      disabled={!!budgetDetails.imageMetadata}
                      size="small"
                    >
                      Upload Image
                      <input
                        type="file"
                        hidden
                        onChange={(e) => handleBoqImage(e)}
                        accept="image/*"
                      />
                    </Button>
                  </Grid>

                  {budgetDetails?.imageMetadata && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "110px",
                        position: "relative",
                      }}
                    >
                      <img
                        src={budgetDetails?.imageMetadata?.image}
                        alt="Uploaded BOQ"
                        style={{
                          width: "100px",
                          height: "100px",
                          border: "2px solid #ddd",
                          borderRadius: "8px",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          margin: "8px 0",
                        }}
                      />
                      <IconButton
                        onClick={handleDeleteImage}
                        style={{
                          position: "absolute",
                          top: "-2px",
                          right: "-4px",
                          padding: "4px",
                          backgroundColor: "rgba(255, 255, 255, 0.7)",
                          borderRadius: "50%",
                          border: "2px solid red",
                        }}
                      >
                        <CloseIcon style={{ fontSize: "12px", color: "red" }} />{" "}
                      </IconButton>
                    </div>
                  )}
                </>
              )}
            </Grid>

            <Grid
              item
              container
              justifyContent="center"
              gap={sm ? 1 : 2}
              wrap="nowrap"
              marginTop="10px"
            >
              <Grid
                item
                xs={6}
                sx={{ display: "flex", justifyContent: "flex-start" }}
              >
                <GreyStyledButton onClick={handleCloseCreation}>
                  Cancel
                </GreyStyledButton>
              </Grid>
              <Grid
                item
                xs={6}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <StyledButton
                  variant="contained"
                  onClick={validate}
                  disabled={buttonLoader}
                >
                  {isEdit ? "Update" : "Add"} Budget Item
                </StyledButton>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default InclusionModal;
